import { Navigate, Route } from "react-router-dom";
import AcademicLegacyTabRedirect from "./AcademicLegacyTabRedirect";

const useAcademicRoutes = () => (
  <>
    <Route
      path="/academic"
      element={<Navigate to="/academics/obep" replace />}
    />
    <Route path="/academic/:tab" element={<AcademicLegacyTabRedirect />} />
  </>
);

export default useAcademicRoutes;
